import { Mapper } from "../../../../../base/utils/mapper";
import { BusinessModel, DataBusinessModel } from "../../../../../domain/models/configuration/company/business.model";
import { BusinessEntity } from "../../entities/company/business.entity";

export class BusinessImplementationRepositoryMapper<T = DataBusinessModel> extends Mapper<BusinessEntity<T>, BusinessModel<T>> {

    mapFrom(param: BusinessEntity<T>): BusinessModel<T> {
        return {
            data: param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors: param.errors,
            pagination:param.pagination
        };
    }

    mapTo(param: BusinessModel<T>): BusinessEntity<T> {
        return {
            data: param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors: param.errors,
            pagination:param.pagination
        };
    }
}